export const setNameRowDetail = (index?: number) =>
  `schedulesAddDetail.${index}`
